// Generated by ReScript, PLEASE EDIT WITH CARE

import * as IssuesEntityMapper from "../entity-mapper/IssuesEntityMapper.bs.js";
import * as ActionsEntityMapper from "../entity-mapper/ActionsEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as TicketBasicInfoEntityMapper from "../entity-mapper/TicketBasicInfoEntityMapper.bs.js";
import * as CreateTicketResponseEntityMapper from "../entity-mapper/CreateTicketResponseEntityMapper.bs.js";

var execute = CreateTicketResponseEntityMapper.execute;

var CreateTicketResponseConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var CreateTicketResponseConverter = partial_arg(CreateTicketResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = TicketBasicInfoEntityMapper.execute;

var TicketInfoConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var TicketInfoResponseConverter = partial_arg$1(TicketInfoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = IssuesEntityMapper.execute;

var TicketIssuesConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var TicketIssuesResponseConverter = partial_arg$2(TicketIssuesConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = ActionsEntityMapper.execute;

var TicketActionsConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var TicketActionsResponseConverter = partial_arg$3(TicketActionsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  CreateTicketResponseConfig ,
  CreateTicketResponseConverter ,
  TicketInfoConfig ,
  TicketInfoResponseConverter ,
  TicketIssuesConfig ,
  TicketIssuesResponseConverter ,
  TicketActionsConfig ,
  TicketActionsResponseConverter ,
  
}
/* CreateTicketResponseConverter Not a pure module */
